import React from 'react';
import { useTranslation } from '../../../i18n';
import { getCategoryLabel } from '../../../i18n/helpers';
import { getCategoriesForGame } from '../../../config/categories';
import { AppIcon } from '../icons';
import './CategoryVote.css';

interface CategoryVoteProps {
  gameType: string;
  myCategoryVotes: string[];
  categoryVotes: Record<string, number>;
  onCategoryVote: (category: string) => void;
  maxVotes?: number;
  disabled?: boolean;
}

const CategoryVote: React.FC<CategoryVoteProps> = ({
  gameType,
  myCategoryVotes,
  categoryVotes,
  onCategoryVote,
  maxVotes = 3,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const categories = getCategoriesForGame(gameType);

  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="category-votes-section">
      <h3 className="category-votes-header">
        <AppIcon name="howToVote" fontSize="small" /> {t('lobby.categories.voteHeader')}
        <span className="category-votes-count">
          ({myCategoryVotes.length}/{maxVotes})
        </span>
      </h3>
      
      <div className="category-votes-chips">
        {categories.map((category) => {
          const isVoted = myCategoryVotes.includes(category.value);
          const voteCount = categoryVotes[category.value] || 0;
          return (
            <button
              key={category.value}
              onClick={() => !disabled && onCategoryVote(category.value)}
              disabled={disabled}
              className={`category-vote-chip ${isVoted ? 'voted' : ''} ${disabled ? 'disabled' : ''}`}
            >
              <span>{category.icon}</span>
              <span>{getCategoryLabel(category.value)}</span>
              {voteCount > 0 && (
                <span className="category-vote-chip-count">
                  {voteCount}
                </span>
              )}
            </button>
          );
        })}
      </div>

      <p className="category-votes-explanation">
        {Object.keys(categoryVotes).length > 0 
          ? t('lobby.categories.explanationWithVotes')
          : t('lobby.categories.explanationNoVotes')}
      </p>
    </div>
  );
};

export default CategoryVote;
